import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { iconWarningV2 } from "assets/icons";
import { ConfirmationModalContainer } from "./ConfirmationModal.styles";
import { Loader } from "components/Loader";
import { Button } from "components/Button/index";

const ConfirmationModal = ({
  title,
  show,
  type = "",
  icon = iconWarningV2,
  onHide,
  onConfirm,
  cancelButtonText = "No",
  confirmButtonText = "Yes",
  description,
  confirmButtonClass,
  isLoading,
  cancelButtonClass = "",
}) => {
  return (
    <ConfirmationModalContainer show={show} onHide={onHide} title={title}>
      {icon && <img src={icon} />}
      <div className="title">{title}</div>
      <div
        className="description"
        dangerouslySetInnerHTML={{ __html: description }}
      ></div>
      <div className="actions">
        <Button
          className={classNames("btn-confirm", confirmButtonClass, {
            "walkthrough-btn": type == "walkthrough",
          })}
          onClick={onConfirm}
        >
          {isLoading ? <Loader className="on-btn" /> : confirmButtonText}
        </Button>

        {type !== "walkthrough" && (
          <Button
            className={classNames("btn-cancel", cancelButtonClass)}
            onClick={onHide}
          >
            {cancelButtonText}
          </Button>
        )}
      </div>
    </ConfirmationModalContainer>
  );
};

ConfirmationModal.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  show: PropTypes.bool,
  isLoading: PropTypes.bool,
  icon: PropTypes.string,
  description: PropTypes.string,
  onHide: PropTypes.func,
  onConfirm: PropTypes.func,
  cancelButtonText: PropTypes.string,
  confirmButtonText: PropTypes.string,
  confirmButtonClass: PropTypes.string,
  cancelButtonClass: PropTypes.string,
};

export default ConfirmationModal;
